import {DescriptionModel} from '../shared/description.model';
import {StringExtensionModel} from '../extensions/string-extension.model';
import {UserModel} from '../authentication/user.model';
import {AssetsHelper} from '../extensions/assets-helper.model';

export class SkillGroupBaseModel {

  public _id: string;

  public name: string;
  public translatedName = new DescriptionModel();
  public category: string;
  public questionIds: string[] = [];
  public order: number;

  public createdAt: Date;
  public updatedAt: Date;

  static generate(json: any, skillGroup: SkillGroupBaseModel = null): SkillGroupBaseModel {

    if (!skillGroup) {
      skillGroup = new SkillGroupBaseModel();
    }

    skillGroup._id = json._id;
    skillGroup.category = json.category;
    skillGroup.order = json.order;

    if (typeof json.name === 'string') {
      skillGroup.name = json.name;
    }

    if (typeof json.translatedName === 'object' && json.translatedName) {
      skillGroup.translatedName = DescriptionModel.generateModel(json.translatedName);
    }

    if (json.questionIds && json.questionIds.length > 0) {
      if (typeof json.questionIds[0] === 'string') {
        skillGroup.questionIds = json.questionIds;
      } else if (typeof json.questionIds[0] === 'object') {
        skillGroup.questionIds = json.questionIds.map((q: any) => q._id);
      }
    }

    if (json.createdAt) {
      skillGroup.createdAt = new Date(json.createdAt);
    }

    if (json.updatedAt) {
      skillGroup.updatedAt = new Date(json.updatedAt);
    }

    return skillGroup;

  }

  static generateModels(jsonList: any[]): SkillGroupBaseModel[] {

    const list = [];

    for (const json of jsonList) {
      list.push(this.generate(json));
    }

    return list;

  }

  getTwoInitials(): string {

    return StringExtensionModel.getInitials(this.name, 2);
  }

  getCategoryIconURL(): string {

    return AssetsHelper.categoryIconURL(this.category);
  }

  getTranslatedName(): string {

    if (UserModel.getCurrent() && this.translatedName) {
      return this.translatedName[UserModel.getCurrent().culture];
    }

    return this.translatedName['en-US'];

  }

}

export class SkillGroupFilter {

  skip = 0;
  limit: number;

  name: string;
  category: string;
  skillGroupIds: string;
  excludeSkillGroupIds: string;

  sortByName = 1;
  sortByOrder = 1;

}
